import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useFormattingContext } from '../../organisms/FormattingProvider/FormattingContext'
import ProgressBar from '../../atoms/ProgressBar'

export const ProgressBlock = ({
  title: _title,
  description: _description,
  metric: _metric,
  percentage,
  formats,
  componentClasses,
  style,
  progressBarProps,
  ...rest
}) => {
  const { formatter } = useFormattingContext()

  const title = useMemo(() => formats?.title ? formatter(_title, formats.title) : _title, [formats, _title, formatter])
  const description = useMemo(() => formats?.description ? formatter(_description, formats.description) : _description, [formats, _description, formatter])
  const metric = useMemo(() => formats?.metric ? formatter(_metric, formats.metric) : _metric, [formats, _metric, formatter])

  return (
    <div className={clsx('flex flex-col gap-sm w-full', componentClasses?.container)} style={style} {...rest}>
      {(!!title?.length || metric) && (
        <div className='flex justify-between items-center'>
          {!!title?.length && <p className={clsx('font-size-md m-0', componentClasses?.title)}>{title}</p>}
          {!!metric && (
            <div>
              <p className={clsx('font-size-md m-0', componentClasses?.metric)}>{metric}</p>
            </div>
          )}
        </div>
      )}
      <ProgressBar
        additionalClasses={componentClasses?.progressBar}
        animate
        showPercentage
        percentage={percentage}
        backgroundColor='var(--color-neutral-200)'
        color='var(--color-primary-500)'
        {...progressBarProps}
      />
      {!!description?.length && (
        <p className={clsx('font-size-sm m-0', componentClasses?.description)}>{description}</p>
      )}
    </div>
  )
}

ProgressBlock.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  metric: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  percentage: PropTypes.number,
  formats: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    metric: PropTypes.string
  }),
  componentClasses: PropTypes.shape({
    container: PropTypes.string,
    progressBar: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    metric: PropTypes.string
  }),
  style: PropTypes.object,
  progressBarProps: PropTypes.object
}
